import { atom } from 'jotai'
import type { TProduct } from '../types/product.types'

export const enrollStarterKitProductsState = atom<TProduct[]>([])
